<script setup></script>

<template>
  <div id="auth" class="tw-max-h-screen">
    <slot />
  </div>
</template>

<style scoped>
#auth {
  background: #5171ff;
}
</style>
